module.exports = __webpack_public_path__ + "img/NekoBox.ec17c266.png";